import { SystemStatusPage } from "@/pages/systemStatus/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/system-status")({
    component: SystemStatusPage,
});
